import { MARKET_INTELLIGENCE_CREDIT_TYPE } from '@/services/endpoints/credits';
import { useCreditFeatureCheck, type UseCreditFeatureCheckResult } from './useCreditFeatureCheck';

type SkipArg = { skip?: boolean };

export const useWhatsAppCreditCheck = (args: SkipArg = {}): UseCreditFeatureCheckResult =>
  useCreditFeatureCheck({ type: 'WHATSAPP', skip: args.skip });

export const useSmsCreditCheck = (args: SkipArg = {}): UseCreditFeatureCheckResult =>
  useCreditFeatureCheck({ type: 'SMS', skip: args.skip });

export const useEmailCreditCheck = (args: SkipArg = {}): UseCreditFeatureCheckResult =>
  useCreditFeatureCheck({ type: 'EMAIL', skip: args.skip });

export const useMarketIntelligenceCreditCheck = (args: SkipArg = {}): UseCreditFeatureCheckResult =>
  useCreditFeatureCheck({ type: MARKET_INTELLIGENCE_CREDIT_TYPE, skip: args.skip });
